const form = document.querySelector('.js-dynamic-labels');

form && checkingIfFieldsAreEmpty(form);


function checkingIfFieldsAreEmpty(form) {
  const handler = e => {
    const field = e.target.closest('.field');
    if (!field) return;
    const isEmpty = e.target.value === '';
    // field.classList.add('changed');
    field.classList.toggle('empty', isEmpty);
    field.classList.toggle('not-empty', !isEmpty);
  }

  [...form.elements].forEach(el => {
    if (el.tagName === 'BUTTON') return;
    const type = (el.tagName === 'SELECT') ? 'change' : 'input';
    el.addEventListener(type, handler);
    el.dispatchEvent(new Event(type));
  });

  form.onreset = e => [...form.querySelectorAll('.field.changed.not-empty')].forEach(
    el => el.classList.remove('not-empty')
  );
}



//////////////////
// WEBPACK FOOTER
// ./src/js/forms/form-labels.js
// module id = 10
// module chunks = 0